import { ChangeDetectionStrategy, Component, inject, OnInit } from "@angular/core";
import { MatTabsModule } from "@angular/material/tabs";
import { Router, RouterLink, RouterLinkActive, RouterOutlet } from "@angular/router";
import { NextHorseRaceComponent } from "./next-horse-race/next-horse-race.component";
import { TranslateModule } from "@ngx-translate/core";
import { AsyncPipe } from "@angular/common";
import { NavService } from "../../../../../../shared/src/lib/services/nav.service";
import { combineLatest, map, Observable } from "rxjs";
import { LoaderService } from "../../../../../../shared/src/lib/services/loader.service";

@Component({
  selector: "app-home",
  templateUrl: "./home.component.html",
  styleUrl: "./home.component.scss",
  imports: [MatTabsModule, RouterLink, RouterLinkActive, RouterOutlet, NextHorseRaceComponent, TranslateModule, AsyncPipe],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HomeComponent implements OnInit {
  router = inject(Router);
  loading$!: Observable<boolean>;
  loader = inject(LoaderService);
  navService = inject(NavService);
  navItems = [
    {
      label: "Cricket",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["home", "highlights", "cricket"],
          },
        },
      ],
    },
    {
      label: "Soccer",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["home", "highlights", "soccer"],
          },
        },
      ],
    },
    {
      label: "Tennis",
      path: [
        "/app/main",
        {
          outlets: {
            navigation: ["sports"],
            content: ["home", "highlights", "tennis"],
          },
        },
      ],
    },
  ];

  ngOnInit() {
    this.loading$ = combineLatest([this.loader.isLoading("/bf/match-odds-markets"), this.loader.isLoading("/market/status")]).pipe(
      map(([loadingMarkets, loadingMarketStatus]) => loadingMarkets || loadingMarketStatus),
    );
  }

  isCurrentRoute(label: string) {
    return this.router.url.includes(String(label).toLowerCase());
  }
}
